<ng-container *ngIf="isBrowser">
    <div class="tmp-section-item-wrapper">
        <span multilang class="tmp-section-title">{{'Dem Meer ganz nah sein' }}?</span>
        <div class="tmp-section-body tmp-flexy">
            @if(!partner?.filters?.hideMeerblick) {
            <button class="tmp-f-btn" [class.tmp-f-btn-selected]="meerblibk" (click)="selectBlink()"
                matRipple>{{'Meerblick' }}</button>
            }
            @if(!partner?.filters?.hideMeerseite) {
            <button class="tmp-f-btn tmp-m-left" [class.tmp-f-btn-selected]="meerseite" (click)="selectSeite()"
                matRipple>{{'Meerseite' }}</button>
            }
        </div>
    </div>
</ng-container>